module.exports = __webpack_public_path__ + "static/media/9.0a7f9d07.png";